import { PersonOutline24Icon } from "@vygruppen/spor-icon-react";
import { Heading, Text } from "shared/components/Spor";
import { useUserInfo } from "shared/hooks/useUserInfo";
import styled from "styled-components";

const ProfileContainer = styled.div`
  position: relative;
  list-style: none;
  padding-right: 12px;
  overflow: auto;
  margin: 0;
  padding-top: 15px;
  padding-bottom: 15px;

  background-color: ${({ theme }) => theme.colorBackgroundMain};
`;

const IconNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-left: 0;
`;

const HeadingContainer = styled.div`
  margin-top: 4px;
`;

const PersonOutline24IconStyled = styled(PersonOutline24Icon)`
  align-self: center;
  margin-left: 16px;
  margin-right: 8px;
`;

const TextContainer = styled.div`
  margin-left: 48px;
`;

const ProfileDisplay = () => {
  const { displayName, email } = useUserInfo();

  return (
    <ProfileContainer>
      <IconNameContainer>
        <PersonOutline24IconStyled />
        <HeadingContainer>
          <Heading as="h1" variant="sm" fontWeight="Bold">
            {displayName}
          </Heading>
        </HeadingContainer>
      </IconNameContainer>

      <TextContainer>
        <Text variant="ls">{email}</Text>
      </TextContainer>
    </ProfileContainer>
  );
};

export default ProfileDisplay;
